import serviceEventQueries from "$/lib/queries/service-event-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/event/$eventId")({
  loader: async ({ context: { queryClient }, params: { eventId } }) => {
    const event = await queryClient.fetchQuery(
      serviceEventQueries.detail(eventId),
    )
    return {
      crumb: event.title,
    }
  },
})
